var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRechercher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5416 16.643L13.4166 13.518M4.45825 9.76803C4.45825 6.89154 6.7901 4.55969 9.66658 4.55969C12.5431 4.55969 14.8749 6.89154 14.8749 9.76803C14.8749 12.6445 12.5431 14.9764 9.66658 14.9764C6.7901 14.9764 4.45825 12.6445 4.45825 9.76803Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechercher);
export default __webpack_public_path__ + "static/media/rechercher.7b2bb461f1b3cf883c7fbf96a06ce593.svg";
export { ForwardRef as ReactComponent };